module.exports = require("core-js/library/fn/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-prototype-of.js
// module id = 31
// module chunks = 0